var _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 76,
    viewBox: "0 0 88 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2487_11538)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.8703,
    cy: 61.1353,
    rx: 31.8703,
    ry: 2.86474,
    fill: "#154AD2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_2487_11538)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.8705,
    cy: 60.5175,
    rx: 26.857,
    ry: 1.79046,
    fill: "#001856"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2487_11538)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    width: 60.8,
    height: 60.8,
    rx: 12.125,
    fill: "url(#paint0_linear_2487_11538)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    width: 60.8,
    height: 60.8,
    rx: 12.125,
    fill: "url(#paint1_radial_2487_11538)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter2_f_2487_11538)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.925,
    y: 2.50469,
    width: 47.6018,
    height: 8.35116,
    rx: 4.17558,
    fill: "url(#paint2_linear_2487_11538)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7,
    filter: "url(#filter3_f_2487_11538)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1016,
    y: 4.175,
    width: 39.2506,
    height: 2.50535,
    rx: 1.25267,
    fill: "url(#paint3_linear_2487_11538)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter4_f_2487_11538)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8656,
    y: 9.1875,
    width: 47.6016,
    height: 8.35119,
    rx: 4.1756,
    transform: "rotate(90 69.8656 9.1875)",
    fill: "url(#paint4_linear_2487_11538)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter5_f_2487_11538)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.1953,
    y: 13.3625,
    width: 39.2505,
    height: 2.50536,
    rx: 1.25268,
    transform: "rotate(90 68.1953 13.3625)",
    fill: "url(#paint5_linear_2487_11538)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter6_f_2487_11538)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 47.6016,
    height: 8.35119,
    rx: 4.1756,
    transform: "matrix(-8.74231e-08 1 1 8.74225e-08 15.5844 9.1875)",
    fill: "url(#paint6_linear_2487_11538)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter7_f_2487_11538)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 39.2505,
    height: 2.50536,
    rx: 1.25268,
    transform: "matrix(-8.74231e-08 1 1 8.74225e-08 17.2547 13.3609)",
    fill: "url(#paint7_linear_2487_11538)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_2487_11538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1989 27.6C36.2871 27.6 35.548 28.3391 35.548 29.2509V30.9018H33.8971C32.0736 30.9018 30.5953 32.38 30.5953 34.2036V50.7125C30.5953 52.536 32.0736 54.0143 33.8971 54.0143H53.7079C55.5314 54.0143 57.0097 52.536 57.0097 50.7125V34.2036C57.0097 32.38 55.5314 30.9018 53.7079 30.9018H52.057V29.2509C52.057 28.3391 51.3179 27.6 50.4061 27.6C49.4943 27.6 48.7552 28.3391 48.7552 29.2509V30.9018H38.8498V29.2509C38.8498 28.3391 38.1107 27.6 37.1989 27.6ZM37.1989 35.8545C36.2871 35.8545 35.548 36.5936 35.548 37.5054C35.548 38.4171 36.2871 39.1563 37.1989 39.1563H50.4061C51.3179 39.1563 52.057 38.4171 52.057 37.5054C52.057 36.5936 51.3179 35.8545 50.4061 35.8545H37.1989Z",
    fill: "url(#paint8_linear_2487_11538)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.548 31.5658H36.212V30.9018V29.2509C36.212 28.7058 36.6538 28.264 37.1989 28.264C37.744 28.264 38.1858 28.7058 38.1858 29.2509V30.9018V31.5658H38.8498H48.7552H49.4192V30.9018V29.2509C49.4192 28.7058 49.861 28.264 50.4061 28.264C50.9512 28.264 51.393 28.7058 51.393 29.2509V30.9018V31.5658H52.057H53.7079C55.1647 31.5658 56.3457 32.7467 56.3457 34.2036V50.7125C56.3457 52.1693 55.1647 53.3503 53.7079 53.3503H33.8971C32.4403 53.3503 31.2593 52.1693 31.2593 50.7125V34.2036C31.2593 32.7467 32.4403 31.5658 33.8971 31.5658H35.548ZM37.1989 35.1905C35.9204 35.1905 34.884 36.2269 34.884 37.5054C34.884 38.7838 35.9204 39.8202 37.1989 39.8202H50.4061C51.6846 39.8202 52.721 38.7838 52.721 37.5054C52.721 36.2269 51.6846 35.1905 50.4061 35.1905H37.1989Z",
    stroke: "url(#paint9_linear_2487_11538)",
    strokeWidth: 1.32793,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter9_dd_2487_11538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3413 -8.24063H36.2422V9.35112H32.7407C31.5576 9.35112 30.9651 10.7815 31.8017 11.618L42.8313 22.6476C43.3499 23.1662 44.1907 23.1662 44.7093 22.6476L55.739 11.618C56.5755 10.7815 55.983 9.35112 54.8 9.35112H51.3413V-8.24063Z",
    fill: "url(#paint10_linear_2487_11538)",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2487_11538",
    x: 0.541029,
    y: 46.8116,
    width: 86.6586,
    height: 28.6474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.72949,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2487_11538",
    x: 14.8649,
    y: 56.5784,
    width: 58.0111,
    height: 7.87804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07428,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2487_11538",
    x: 15.5845,
    y: -0.835784,
    width: 54.2828,
    height: 15.0321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2487_11538",
    x: 19.7611,
    y: 0.834527,
    width: 45.9316,
    height: 9.18629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2487_11538",
    x: 58.174,
    y: 5.84703,
    width: 15.0321,
    height: 54.2826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2487_11538",
    x: 62.3495,
    y: 10.022,
    width: 9.18632,
    height: 45.9314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2487_11538",
    x: 12.2439,
    y: 5.84703,
    width: 15.0321,
    height: 54.2826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2487_11538",
    x: 13.9142,
    y: 10.0205,
    width: 9.18632,
    height: 45.9314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67024,
    result: "effect1_foregroundBlur_2487_11538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_2487_11538",
    x: 19.9719,
    y: 22.2883,
    width: 47.6612,
    height: 47.6612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.21335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.60667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2487_11538"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.31171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.31171
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2487_11538",
    result: "effect2_dropShadow_2487_11538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2487_11538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_2487_11538",
    x: 20.7867,
    y: -13.5523,
    width: 45.9673,
    height: 52.5241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.21335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.60667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2487_11538"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.31171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.31171
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2487_11538",
    result: "effect2_dropShadow_2487_11538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2487_11538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2487_11538",
    x1: 26.7098,
    y1: 2.85552e-7,
    x2: 57.9209,
    y2: 65.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF33AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7500D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000958"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2487_11538",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.04 -3.31024) rotate(-26.4881) scale(69.6292 63.0704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C520FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3500A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2487_11538",
    x1: 42.7259,
    y1: 2.50469,
    x2: 42.7259,
    y2: 10.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2487_11538",
    x1: 42.7269,
    y1: 4.175,
    x2: 42.7269,
    y2: 6.68035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2487_11538",
    x1: 93.6665,
    y1: 9.1875,
    x2: 93.6665,
    y2: 17.5387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2487_11538",
    x1: 87.8205,
    y1: 13.3625,
    x2: 87.8205,
    y2: 15.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2487_11538",
    x1: 23.8008,
    y1: 0,
    x2: 23.8008,
    y2: 8.35119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2487_11538",
    x1: 19.6252,
    y1: 0,
    x2: 19.6252,
    y2: 2.50536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2487_11538",
    x1: 43.8025,
    y1: 27.6,
    x2: 43.8025,
    y2: 54.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2487_11538",
    x1: 43.8025,
    y1: 27.6,
    x2: 43.8025,
    y2: 54.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2487_11538",
    x1: 43.7703,
    y1: -4.25675,
    x2: 43.7703,
    y2: 23.0364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255965,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2487_11538"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    width: 60.8,
    height: 60.8,
    rx: 12.125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttend);
export default __webpack_public_path__ + "static/media/attend.ce4a7bdcda9817c19bcbcdd11e9ad857.svg";
export { ForwardRef as ReactComponent };